




import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {Check,X} from 'lucide-react';

  
const FAQQuizAddMoreAnswer=({index ,
    answer,id,onRemove,changeItemAnswer})=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    const [itemAnswer, setItemAnswer] = useState(answer?.answer); 
  


    
     useEffect(()=>{
    
     },[])



     const [text, setText] = useState("");
     const [wordCount, setWordCount] = useState(0);
   
     const handleChange = (event) => {
       const inputText = event.target.value;
       const words = inputText.trim().split(/\s+/); // Split by spaces, ignoring extra spaces
       const count = words[0] === "" ? 0 : words.length; // Handle empty input edge case
   
       if (count <= 50) {
         setText(inputText);
         setWordCount(count);
       }
     };
   return(<><div 
   
   
   style={{padding:"0px",margin:"0px",marginTop:"10px",borderRadius:"10px",background:"#fff",
   }}> 
    { <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",
        float:"right",borderRadius:"50%",
    margin:"10px", marginTop:"20px",
      border:"1px dashed #958FDA"}} onClick={()=>{onRemove(id);}}><X  style={{margin:"6px"}} 
      color="#958FDA" size={18}/></div>}
    
 
<div  style={{}}><div style={{}}>
    
    
    </div> 
    <div>
    <div className="" style={{marginTop:"30px",display:"grid",gridTemplateColumns:"100%"}} > 
    
      <div></div>
        {<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   cols={2} rows={2} value={!itemAnswer?"Answer"+(index+1)+": ":itemAnswer} type="text"
     placeholder={("Add Answer "+(index+1))}
        onChange={(e)=>{changeItemAnswer(id,e.target.value);setItemAnswer(e.target.value);}}
        style={{height:"60px",minWidth:"150px"}}  className="inputTextCardFAQ"></textarea>}</div>
  
     
    </div>
    
    </div>
    
    </div></>)
}  

export default FAQQuizAddMoreAnswer;
